// extracted by mini-css-extract-plugin
module.exports = {"desktopModalPaper":"ExlyResponsesModalStyles_desktopModalPaper__3t0tQ"};